import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Grid, TextField, MenuItem, Alert, Typography, Box, Chip
} from "@mui/material";
import { useState } from "react";
import api from "../service/api";

/* ─── EV stock locations (matches evStockSchema enum) ──────────────────── */
const EV_LOCATIONS = ["Chaitanyapur", "Mahisadal"];

const TransferDialog = ({ open, onClose, bike, onSuccess }) => {
  const [form, setForm] = useState({
    toLocation:        "",
    transferChallanNo: "",
    transferDate:      new Date().toISOString().split("T")[0],
    transferCost:      "",
  });
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (error) setError("");
  };

  const handleSubmit = async () => {
    setError("");

    if (!form.toLocation) {
      setError("Please select a destination location.");
      return;
    }

    if (bike?.location && bike.location.toLowerCase() === form.toLocation.toLowerCase()) {
      setError("Vehicle is already at this location.");
      return;
    }

    try {
      setLoading(true);
      await api.post("/stock-transfer", {
        stockId:           bike._id,          // backend uses stockId, not bikeId
        toLocation:        form.toLocation,
        transferChallanNo: form.transferChallanNo || undefined,
        transferCost:      form.transferCost ? Number(form.transferCost) : undefined,
        transferDate:      form.transferDate || undefined, // backend uses transferDate
      });

      onSuccess();
      handleClose();
    } catch (err) {
      setError(err?.response?.data?.message || "Transfer failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setForm({
      toLocation:        "",
      transferChallanNo: "",
      transferDate:      new Date().toISOString().split("T")[0],
      transferCost:      "",
    });
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 3 } }}>

      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" fontWeight={700}>Transfer Vehicle</Typography>
        {/* show current bike info */}
        {bike && (
          <Box display="flex" gap={1} mt={0.5} flexWrap="wrap">
            {bike.model      && <Chip label={bike.model}              size="small" color="primary" variant="outlined" />}
            {bike.engine     && <Chip label={`Eng: ${bike.engine}`}   size="small" variant="outlined" />}
            {bike.location   && <Chip label={`From: ${bike.location}`} size="small" sx={{ bgcolor: "#FFF3E0", color: "#E65100" }} />}
          </Box>
        )}
      </DialogTitle>

      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
            {error}
          </Alert>
        )}

        <Grid container spacing={2} mt={0.5}>

          {/* DATE — maps to transferDate in backend */}
          <Grid item xs={12}>
            <TextField
              fullWidth size="small"
              label="Transfer date"
              type="date"
              name="transferDate"
              value={form.transferDate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
            />
          </Grid>

          {/* TO LOCATION — maps to toLocation in backend */}
          <Grid item xs={12}>
            <TextField
              select fullWidth size="small"
              label="To location *"
              name="toLocation"
              value={form.toLocation}
              onChange={handleChange}
              error={!!error && !form.toLocation}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
            >
              {EV_LOCATIONS
                .filter((l) => l !== bike?.location) // hide current location
                .map((l) => (
                  <MenuItem key={l} value={l}>{l}</MenuItem>
                ))}
            </TextField>
          </Grid>

          {/* CHALLAN NO — maps to transferChallanNo in backend */}
          <Grid item xs={12}>
            <TextField
              fullWidth size="small"
              label="Challan no."
              name="transferChallanNo"
              value={form.transferChallanNo}
              onChange={handleChange}
              placeholder="e.g. CHN-2024-001"
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
            />
          </Grid>

          {/* TRANSFER COST — maps to transferCost in backend */}
          <Grid item xs={12}>
            <TextField
              fullWidth size="small"
              label="Transfer cost (₹)"
              name="transferCost"
              type="number"
              value={form.transferCost}
              onChange={handleChange}
              placeholder="0"
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
            />
          </Grid>

        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={handleClose} disabled={loading}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || !form.toLocation}
        >
          {loading ? "Transferring…" : "Transfer"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

 export default TransferDialog;
 